import type { RouteLocationNormalized } from "vue-router";
import { useAuthStore } from "@/application/stores/authStore";
import { useAppStore } from "@/application/stores/app";

export default function authGuard(to: RouteLocationNormalized) {
  const authStore = useAuthStore();
  const appStore = useAppStore();

  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    appStore.setRedirectUrl();
    return { name: "auth.login" };
  }

  if (
    authStore.isLoggedIn &&
    appStore.redirectUrl &&
    to.name !== "auth.login"
  ) {
    const redirectUrl = appStore.redirectUrl;
    appStore.clearRedirectUrl();
    if (redirectUrl !== to.fullPath) return redirectUrl;
  }

  if (to.name === "auth.login" && authStore.isLoggedIn) {
    return { name: "federations.index" };
  }

  return true;
}
